<template>
  <mds-tr class="custom-table__row" @click.native="$emit('clickedRow', record)">
    <mds-td class="custom-table__column">{{ record.name }}</mds-td>
    <mds-td class="custom-table__column">
      <schedule-status :status="record.status" :item-id="record.id" />
    </mds-td>
    <mds-td class="custom-table__column">
      <div>{{ record.lastRun.date }}</div>
      <div v-show="record.lastRun.date !== '—'" class="custom-table__time">
        {{ lastRunDate }}
      </div>
    </mds-td>
    <mds-td class="custom-table__column">
      <div>{{ record.nextRun.date }}</div>
      <div v-show="record.nextRun.date !== '—'" class="custom-table__time">
        {{ nextRunDate }}
      </div>
    </mds-td>
    <mds-td class="custom-table__column">{{ record.recurrence }}</mds-td>
    <mds-td class="custom-table__column">
      <mds-button
        v-for="(action, key) in actions"
        :key="key"
        :icon="action.icon"
        :disabled="disableDownload"
        size="small"
        variation="flat"
        class="custom-table__action"
        @click.native="$emit(action.event, [record.id, $event])"
      >
        {{ translate(action.name) }}
      </mds-button>
    </mds-td>

    <mds-td class="custom-table__column">
      <CustomTableActions
        :record="record"
        :rowId="record.id"
        v-on="$listeners"
      />
    </mds-td>
  </mds-tr>
</template>

<script>
import { MdsButton } from '@mds/button'
import { MdsTr, MdsTd } from '@mds/data-table'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import CustomTableActions from './CustomTableActions.vue'
import defaultConfig from '@/config/i18n'
import { SCHEDULE_STATUS } from '../config/constants'
import isEqual from 'lodash/isEqual'
import ScheduleStatus from '../scheduleStatus/ScheduleStatus.vue'

export default {
  name: 'CustomTableRowSchedule',
  components: {
    MdsButton,
    MdsTr,
    MdsTd,
    CustomTableActions,
    ScheduleStatus,
  },
  props: {
    record: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],
  computed: {
    disableDownload() {
      return !isEqual(this.record.status?.variation, SCHEDULE_STATUS.success)
    },
    lastRunDate() {
      const { lastRun } = this.record
      return `${lastRun.time} ${lastRun.timezone} (${lastRun.utcOffset})`
    },
    nextRunDate() {
      const { nextRun } = this.record
      return `${nextRun.time} ${nextRun.timezone} (${nextRun.utcOffset})`
    },
  },
  data() {
    return {
      defaultConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@mds/constants';
@import '@mds/typography';

.custom-table {
  &__row:hover {
    background-color: $mds-color-neutral-90;
  }
  &__row {
    cursor: pointer;
    height: $mds-space-8-x;

    &:first-child {
      .custom-table__column {
        border-top: none;
      }
    }

    &:nth-child(even):hover {
      background-color: $mds-color-neutral-90;
    }
    &:nth-child(even) {
      background-color: $mds-background-color-light-gray;
    }
  }

  &__column {
    @include mds-body-text-s();
    vertical-align: middle;
    padding-left: $mds-space-1-x;
  }
  &__time {
    color: $mds-color-neutral-37;
  }
}
</style>
